<template>
  <div class="card">
    <div class="card-row">
      <span class="card-row-label">{{ t('monthly_visits') }}</span>
      <span>{{ market.monthly_visit || '--' }}</span>
    </div>
    <div class="card-row">
      <span class="card-row-label">{{ t('registered_company') }}</span>
      <span>{{ market.registered_company || '--' }}</span>
    </div>
    <div class="card-row">
      <span class="card-row-label">{{ t('founded') }}</span>
      <span>{{
        market.foundation_date && moment(market.foundation_date).format('DD-MM-YYYY') !== 'Invalid date'
          ? moment(market.foundation_date).format('DD-MM-YYYY') : '--'
      }}</span>
    </div>
    <div class="card-row">
      <span class="card-row-label">{{ t('headquarters') }}</span>
      <span>{{ market.headquarters || '--' }}</span>
    </div>
    <div class="card-row">
      <span class="card-row-label">{{ t('key_people') }}</span>
      <span>{{ market.key_people || '--' }}</span>
    </div>
    <div class="card-row">
      <span class="card-row-label">{{ t('items') }}</span>
      <span>{{
        market.supply_statistic?.items || '--'
      }} ({{ market.items_percentage || 0 }}%)</span>
    </div>
    <div class="card-row">
      <span class="card-row-label">{{ t('offers') }}</span>
      <span>{{ market.supply_statistic?.offers || '--' }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MarketFullInfo } from '~/graphql/generated/schema-types';
import moment from 'moment';

defineProps<{
  market: MarketFullInfo
}>();
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.card {
  background: var(--surfaces-low-container);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 12px;

  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--surfaces-on-surface);

    &-label {
      color: var(--surfaces-on-surface-variable);
    }

    span:not(.card-row-label) {
      text-align: right;
    }
  }
}
</style>
